<script setup lang="ts">
const props = defineProps<{
  name?: string
  /**Render with this many rows show to start. Defaults to 4 */
  rows?: number
}>()
const modelValue = defineModel<string | null>()
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="flex w-full flex-col">
    <label
      v-if="props.name"
      :for="props.name"
      class="mb-2 block w-full text-sm font-medium text-gray-900"
      >{{ props.name }}</label
    >
    <textarea
      :id="props.name"
      :name="props.name"
      :rows="props.rows ?? 4"
      v-bind="$attrs"
      v-model="modelValue"
      class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
    />
  </div>
</template>
